import React, { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import NotificationApi from "../../api/NotificationApi";
import AuthService from "../../session/AuthService";
import building from "../../images/building.png";
import equipment from "../../images/equipment.png";
import Vechiles from "../../images/Vechiles.png";
import { Avatar, Pagination } from "@mui/material";
import moment from "moment";

const SafetyNotificationGrid = ({ filterkey, setTotalCount }) => {
  //   const [search, setSearch] = useState(null);
  const [page, setpage] = useState(0);
  const [notificationData, setNotificationData] = useState([]);

  useEffect(() => {
    let obj = {
      page: page,
      //   search: search,
      receiverId: parseInt(AuthService.getUserId()),
      filterkey: filterkey,
    };
    getSafetyNotificationData(obj);
  }, [page, filterkey]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setpage(0);
    }
  };

  const getSafetyNotificationData = (obj) => {
    NotificationApi.getNotificationforAdmin(obj).then((response) => {
      if (response.data && response.data.message === "success") {
        setNotificationData(response.data.data);
        setTotalCount(response.data.data.totalCount);
        // this.setState({
        //   notificationList: response.data.data.notificationList,
        //   totalCount: response.data.data.totalCount,
        //   totalPageno: response.data.data.totalPageno,
        // });
      }
    });
  };

  return (
    <>
      {/* <div className="row" id="titleWithDropdowns">
        <div className="title-column-notification">
          <div className="search-contain ">
            <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

            <div className="search">
              <span className="fa fa-search" onClick={() => setpage(0)}></span>
              <input
                type="text"
                placeholder="Type Here..."
                name="search"
                value={search}
                onKeyPress={handleKeyPress}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div> */}
      <Row>
        <div className="adjust-grid-container">
          <div className="Center-the-Grid">
            <table id="myTable">
              <thead>
                <tr style={{ borderBottom: "1px solid #BCBFBE" }}>
                  {/* <th>Title</th> */}
                  <th>Message</th>
                  <th>Notified Date</th>
                </tr>
              </thead>
              <tbody>
                {notificationData?.notificationList?.length > 0 ? (
                  notificationData?.notificationList?.map((item) => (
                    <tr>
                      <td style={{ padding: "4px" }}>
                        <div style={{ display: "flex", gap: "10px" }}>
                          {item.resourseType === "1" ? (
                            <img
                              src={building}
                              alt="building 1"
                              style={{
                                width: "2rem",
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                          ) : item.resourseType === "2" ? (
                            <img
                              src={equipment}
                              alt="equipment 2"
                              style={{
                                width: "2rem",
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                          ) : item.resourseType === "3" ? (
                            <img
                              src={Vechiles}
                              alt="Vechicles 3"
                              style={{
                                width: "2rem",
                                maxWidth: "100%",
                                height: "auto",
                              }}
                            />
                          ) : (
                            <Avatar sx={{ width: 32, height: 32 }}>N</Avatar>
                          )}
                          <div>
                            {item.notificationType === "safety" && (
                              <>
                                Your{" "}
                                {item.resourseType === "1"
                                  ? "building"
                                  : item.resourseType === "2"
                                  ? "equipment"
                                  : item.resourseType === "3"
                                  ? "vehicle"
                                  : ""}{" "}
                                <strong>{item.title}</strong> is set to expire
                                on <strong>{item.message}</strong>
                              </>
                            )}
                            {item.notificationType === "service" && (
                              <>
                                Time for Service! Your{" "}
                                {item.resourseType === "1"
                                  ? "building"
                                  : item.resourseType === "2"
                                  ? "equipment"
                                  : item.resourseType === "3"
                                  ? "vehicle"
                                  : ""}{" "}
                                <strong>{item.title}</strong> needs servicing
                                today.
                              </>
                            )}
                          </div>
                        </div>
                      </td>

                      {/* <td style={{ padding: "4px" }}>{item.message}</td> */}

                      <td style={{ padding: "4px" }}>
                        {/* {moment(item.createdDate).format("dddd, D MMMM YYYY")} */}
                        {moment.parseZone(item.createdDate).fromNow()}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    {" "}
                    <td
                      style={{
                        fontSize: "larger",
                        fontWeight: "bolder",
                        fontFamily: "Karla",
                      }}
                      colspan="3"
                      align="center"
                    >
                      No Alert Available
                    </td>{" "}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Row>
      <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
        <div className="d-flex justify-content-center">
          <Pagination
            count={notificationData.totalPageno ?? 0}
            onChange={(event, value) => setpage(value - 1)}
            page={page + 1}
          />
        </div>
      </div>
    </>
  );
};

export default SafetyNotificationGrid;
